module.exports = __webpack_public_path__ + "static/media/user.32930e47.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/user.svg
// module id = 151
// module chunks = 1